export const getMilesText = (miles: number | undefined): string =>
  miles === undefined ? 'N/A' : `${new Intl.NumberFormat('en-US').format(miles)}`;

export const getNumberAmountText = (amount: number | undefined): string =>
  amount === undefined
    ? 'N/A'
    : `${new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(amount)}`;

export const getDollarAmountText = (amount: number): string =>
  `${new Intl.NumberFormat('en-US', { minimumFractionDigits: 2 }).format(amount)}`;

export const getCurrencyText = (
  amount: number | undefined | null,
  withSign: boolean,
  emptyIndicator?: string,
): string =>
  amount
    ? `${new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
        style: 'currency',
        currency: 'USD',
      }).format(amount)}`
    : emptyIndicator
      ? emptyIndicator
      : '$0';

export const getAPRText = (apr: number): string =>
  `${new Intl.NumberFormat('en-US', { maximumSignificantDigits: 4 }).format(apr)}`;

export const getDiscountAmountText = (amount: number): string =>
  `$${new Intl.NumberFormat('en-US', { maximumSignificantDigits: 4 }).format(amount)}`;

export const getDiscountPercentText = (percent: number): string => `${percent}%`;
